import ReactRouterPrompt from "react-router-prompt";
import { CDataModalV2 } from "./modal/CDataModalV2";
import { CDButton } from "@cdatacloud/component-library";

interface PromptWithModalProps {
  when: boolean;
  customMessage?: string;
  customTitle?: string;
  navigate?: (path: string) => void;
}

export const PromptWithModal = ({
  when,
  customMessage,
  customTitle,
}: PromptWithModalProps) => {
  const title = customTitle ?? "Unsaved Changes";
  const message =
    customMessage ??
    "If you leave this page, any unsaved changes will be lost. Are you sure you want to leave?";

  return (
    when && (
      <ReactRouterPrompt when={when}>
        {({ isActive, onConfirm, onCancel }) => (
          <PromptModal
            isActive={isActive}
            title={title}
            message={message}
            onConfirm={onConfirm}
            onCancel={onCancel}
          />
        )}
      </ReactRouterPrompt>
    )
  );
};

interface PromptModalProps {
  isActive: boolean;
  title: string;
  message: string;
  onConfirm: (value?: unknown) => void;
  onCancel: (value?: unknown) => void;
}

const PromptModal = (props: PromptModalProps) => {
  const { isActive, title, message, onConfirm, onCancel } = props;

  if (!isActive) {
    return <></>;
  }

  return (
    <CDataModalV2
      close={() => onCancel()}
      displayed={isActive}
      title={title ?? "Unsaved Changes"}
      spacedFooter={false}
      modalSize="lg"
      primaryButton={
        <CDButton color="Danger (Text)" onClick={onConfirm}>
          Leave Page
        </CDButton>
      }
      secondaryButton={
        <CDButton color="Secondary/Text Regular" onClick={onCancel}>
          Cancel
        </CDButton>
      }
    >
      {message}
    </CDataModalV2>
  );
};
